import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService, CustomHttp, ConfigServerService } from '../../../core';
import { MotivoPerdaVendaSearchFilter } from '../filter';
import { MotivoPerdaVenda } from '../motivo-perda-venda';

@Injectable({
    providedIn: 'root'
})
export class MotivoPerdaVendaCrudHttpService implements Crud<MotivoPerdaVenda> {
    resource = 'motivoperdavenda';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todos os motivos cadastrados */
    search(): Observable<MotivoPerdaVenda[]> {
        return this.crudService.search<MotivoPerdaVenda>(this.resource);
    }

    /** Pesquisa todos os motivos utilizando o filtro informado */
    searchWithFilter(filter: MotivoPerdaVendaSearchFilter): Observable<MotivoPerdaVenda[]> {
        // Params
        let params = new HttpParams();
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<MotivoPerdaVenda[]>(this.pathApi, {params});
    }

    /** Procura um único motivo através do seu ID */
    find(id: number): Observable<MotivoPerdaVenda> {
        return this.crudService.find<MotivoPerdaVenda>(this.resource, id);
    }

    /** Carrega um único motivo através do seu ID */
    load(id: number): Observable<MotivoPerdaVenda> {
        return this.crudService.load<MotivoPerdaVenda>(this.resource, id);
    }

    /** Insere um novo motivo */
    insert(entity: MotivoPerdaVenda): Observable<MotivoPerdaVenda> {
        return this.crudService.insert<MotivoPerdaVenda>(this.resource, entity);
    }

    /** Altera um motivo existente */
    update(entity: MotivoPerdaVenda): Observable<MotivoPerdaVenda> {
        return this.crudService.update<MotivoPerdaVenda>(this.resource, entity);
    }

    /** Exclui um motivo através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
